import React, { useState, useEffect, useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col, Card, Button, Table, Accordion } from "react-bootstrap";
import axios from "axios";
import Receipt from "../Receipt.jsx";
import SummaryCard from "./SummaryCard.jsx";
import classes from "./AllSummaryAnalysis.module.css";
import YesAndNoModal from "../Modals/YesAndNoModal.jsx";
import ReactExport from "react-export-excel-fixed-xlsx";
import PermissionContext from "../../../Store/permission-context";

const AllExpendituresAnalysis = (props) => {
  const PCtx = useContext(PermissionContext);
  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
  const [DisplayData, setDisplayData] = useState(true);
  const [ShowModal, setShowModal] = useState(false);
  const [IsPrinting, setIsPrinting] = useState(false);
  const [Message, setMessage] = useState("");
  const [SummaryCash, setSummaryCash] = useState(0);
  const [SummaryPOS, setSummaryPOS] = useState(0);
  const [SummaryCredit, setSummaryCredit] = useState(0);
  const [SummaryTransfer, setSummaryTransfer] = useState(0);
  const [TotalExpenditure, setTotalExpenditure] = useState(0);
  const [ModalType, setModalType] = useState("");

  const [ThisExpenditures, setThisExpenditures] = useState([]);
  const [AllExpendituresDetails, setAllExpendituresDetails] = useState(
    props.Records
  );

  useEffect(() => {}, []);

  //   const ExportToExcel = (ArrData, indx) => {
  //     return (
  //       <ExcelSheet
  //         data={ArrData.ThisExpenditures}
  //         name={ArrData.ThisDate}
  //         key={indx}
  //       >
  //         <ExcelColumn label="Receipt No" value="RID" />
  //         <ExcelColumn label="DATE_OF_TRANSACTION" value="DatePaid" />
  //         <ExcelColumn label="AMOUNT" value="Payable" />
  //         <ExcelColumn label="DISCOUNT" value="Discount" />
  //         <ExcelColumn label="PAID" value="Paid" />
  //         <ExcelColumn label="PAYMENT MODE" value="PaymentMode" />
  //         <ExcelColumn label="STAFF" value="Staff" />
  //         <ExcelColumn label="CUSTOMER" value="Customer" />
  //         <ExcelColumn label="PHONE" value="Phone" />
  //         <ExcelColumn label="PROFIT" value="Profit" />
  //       </ExcelSheet>
  //     );
  //   };

  const TableForPrinting = (ArrData, indx) => {
    let DataPresent = true;
    if (
      ArrData.ThisExpenditures != undefined &&
      ArrData.ThisExpenditures.length > 0
    ) {
      DataPresent = true;
    } else {
      DataPresent = false;
    }
    return (
      <div key={indx}>
        {props.myDates.Category === "Individual" &&
          props.myDates.Staff.toUpperCase()}
        EXPENDITURE REPORTS FOR {ArrData.ThisDate.toUpperCase()}
        {DataPresent && (
          <Table
            striped
            bordered
            responsive
            key={indx}
            className={classes.table4printing}
          >
            <thead>
              <tr>
                <th>SN</th>
                <th>EntryID</th>
                <th>Amount</th>
                <th>Given By</th>
                <th>Given To</th>
                <th>Purpose</th>
                <th>Date Registered</th>
                {props.myDates.Category === "Group" && <th>Del</th>}
              </tr>
            </thead>
            <tbody>
              {ArrData.ThisExpenditures.map((rec, index) => (
                <tr key={index}>
                  <td>
                    {index < ArrData.ThisExpenditures.length - 1
                      ? index + 1
                      : ""}
                  </td>
                  <td>{rec.EntryID}</td>
                  <td>{rec.Amount}</td>
                  <td>{rec.Giver}</td>
                  <td>{rec.Receiver}</td>
                  <td>{rec.Purpose}</td>
                  <td>{rec.DateRegistered}</td>

                  <td>
                    <Button variant="outline-danger" className="btn-sm">
                      -
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        {!DataPresent && <p>Oops! No Record for {ArrData.ThisDate}</p>}
        <hr />
      </div>
    );
  };

  return (
    <Row className={classes.margin4printing}>
      <Col md={12} sm={12} xs={12} className={classes.margin4printing}>
        <Row className={classes.margin4printing}>
          {DisplayData && (
            <Row
              className={`${
                classes.margin4printing
              } ${"justify-content-around"}`}
            >
              <Col md={12} className={classes.hide4printing}>
                <p
                  style={{
                    fontFamily: "Times New Roman",
                    fontSize: "20px",
                    color: "brown",
                    textAlign: "center",
                  }}
                >
                  GENERAL SUMMARY FOR {PCtx.DatesSelected}
                </p>
              </Col>

              <Col md={8} sm={12} xs={12} className={classes.margin4printing}>
                <Row
                  className={`${
                    classes.margin4printing
                  } ${"justify-content-around"}`}
                >
                  <Col
                    md={12}
                    sm={12}
                    xs={12}
                    className={classes.hide4printing}
                  >
                    <Table striped bordered responsive>
                      <thead>
                        <tr>
                          <th className="text-center">Summary Description</th>
                          <th className="text-center">CASH</th>
                          <th className="text-center">POS</th>
                          <th className="text-center">TRANSFER</th>
                          <th className="text-center">CREDIT</th>
                          <th className="text-center">
                            TOTAL (Without Credit)
                          </th>
                          <th className="text-center">
                            GRAND TOTAL (Credit Inclusive)
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className={classes.Received}>
                            All Money Received through
                          </td>
                          <td className={classes.Received}>
                            {PCtx.ReceivedCash}
                          </td>
                          <td className={classes.Received}>
                            {PCtx.ReceivedPOS}
                          </td>
                          <td className={classes.Received}>
                            {PCtx.ReceivedTransfer}
                          </td>
                          <td className={classes.Received}>
                            {PCtx.ReceivedCredit}
                          </td>
                          <td className={classes.Received}>
                            {PCtx.ReceivedPOS +
                              PCtx.ReceivedTransfer +
                              PCtx.ReceivedCash}
                          </td>
                          <td className={classes.Received}>
                            {PCtx.ReceivedCredit +
                              PCtx.ReceivedPOS +
                              PCtx.ReceivedTransfer +
                              PCtx.ReceivedCash}
                          </td>
                        </tr>
                        <tr>
                          <td className={classes.Spent}>
                            All Money Spent from
                          </td>
                          <td className={classes.Spent}>{PCtx.SpentCash}</td>
                          <td className={classes.Spent}>{PCtx.SpentPOS}</td>
                          <td className={classes.Spent}>
                            {PCtx.SpentTransfer}
                          </td>
                          <td className={classes.Spent}>-</td>
                          <td className={classes.Spent}>
                            {PCtx.SpentPOS +
                              PCtx.SpentTransfer +
                              PCtx.SpentCash}
                          </td>
                          <td className={classes.Spent}>
                            {PCtx.SpentPOS +
                              PCtx.SpentTransfer +
                              PCtx.SpentCash}
                          </td>
                        </tr>
                        <tr>
                          <td className={classes.Balance}>Balance</td>
                          <td className={classes.Balance}>
                            {PCtx.ReceivedCash - PCtx.SpentCash}
                          </td>
                          <td className={classes.Balance}>
                            {PCtx.ReceivedPOS - PCtx.SpentPOS}
                          </td>
                          <td className={classes.Balance}>
                            {PCtx.ReceivedTransfer - PCtx.SpentTransfer}
                          </td>
                          <td className={classes.Balance}>
                            {PCtx.ReceivedCredit}
                          </td>
                          <td className={classes.Balance}>
                            {PCtx.ReceivedPOS +
                              PCtx.ReceivedTransfer +
                              PCtx.ReceivedCash -
                              PCtx.SpentCash -
                              PCtx.SpentPOS -
                              PCtx.SpentTransfer}
                          </td>
                          <td className={classes.Balance}>
                            {PCtx.ReceivedCredit +
                              PCtx.ReceivedPOS +
                              PCtx.ReceivedTransfer +
                              PCtx.ReceivedCash -
                              PCtx.SpentCash -
                              PCtx.SpentPOS -
                              PCtx.SpentTransfer}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>

                  <hr className={`${classes.hide4printing} ${"mx-2"}`} />
                  <Col md={2} sm={6} xs={6} className={classes.hide4printing}>
                    <Button variant="info">Print</Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default AllExpendituresAnalysis;
